<template>
    <div id="Nav">
        <div class="menu_list">
            <el-menu
            default-active="0"
            :default-openeds="defaulet"
            :collapse-transition="false"
            active-text-color="#000"
            router
           >
            <el-submenu :index="item.id" v-for="item in menuList" :key="item.id">
              <template slot="title">
                  <span @click="jump(item.path)" style="width: 100%;display: inline-block;" >{{item.title}}</span>
              </template>
              <el-menu-item :index="'/'+subItem.path" v-for="subItem in item.children" :key="subItem.id" :class="$route.params.tabIndex == subItem.id?'active':'' ">
                  <span>{{subItem.title}}</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
    </div>
</template>

<script>
export default {
    name:'NavHeader',
    components:{
    },
    data(){
        return {
            // 默认展开
            defaulet:["0"],
            // 头部菜单列表
            menuList:[
            {
                id:'0',
                title:'我的訂單',
                children:[
                    {
                    id:'1',
                    title:'全部訂單',
                    path:`order/${1}`
                    },
                    {
                    id:'2',
                    title:'待收件',
                    path:`order/${2}`
                    },
                    {
                    id:'3',
                    title:'己收件',
                    path:`order/${3}`
                    },
                    {
                    id:'4',
                    title:'運送中',
                    path:`order/${4}`
                    },
                    {
                    id:'5',
                    title:'己送達',
                    path:`order/${5}`
                    }
                ]
            },
            {
                id:'1',
                title:'個人設置',
                path:"/settings",
            },
            {
                id:'2',
                title:'聯繫人',
                path:"/contacts"
            }
            ],
        }
    },
    methods: {
        //  监听用户点击tab栏菜单
        jump(path){
            if(!path) return
            this.$router.push(path)
        },
    },
}
</script>

<style  lang="less" scope>
    #Nav{
        .menu_list{
            width: 300px;
            overflow: hidden;
            border: none;
            .el-menu-item:focus, .el-menu-item:hover,.el-submenu__title:hover{
                background-color: #F2F2F2 !important;
            }
            .el-menu{
                border-radius: 10px;
                background-color: #F2F2F2;
                border: none;
                .el-menu-item.active{
                    span{
                        color: @colorMain;
                        font-weight:600;
                    }
                }
                .el-submenu{
                    border-bottom: 2px solid #ccc;
                    margin-bottom:10px;
                    padding-bottom:10px;
                }
                .el-submenu:last-child{
                    border-bottom: none;
                }
                .el-menu-item{
                    font-weight: 580;
                    border: none;
                    font-size:16px;
                }
                .el-submenu__title{
                    font-size: 18px;
                    span{
                        font-family:"Source Han Sans HK Regular" ;
                        font-weight:600;
                    }
                i{
                    display: none;
                }
            }
        }
    }
    }
  /* 最大宽度768px 手机 */
@media screen and (max-width: 768px){

}
</style>
